var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16961 1.5H15.8196C16.8354 1.5 17.8096 1.90352 18.5278 2.62178C19.2461 3.34005 19.6496 4.31422 19.6496 5.33V14.9C19.6496 15.4066 19.4484 15.8924 19.0902 16.2506C18.732 16.6088 18.2462 16.81 17.7396 16.81H6.25961C5.75305 16.81 5.26723 16.6088 4.90904 16.2506C4.55084 15.8924 4.34961 15.4066 4.34961 14.9V5.33C4.34961 4.31595 4.75175 3.34329 5.46785 2.62531C6.18396 1.90733 7.15556 1.50265 8.16961 1.5Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16883 16.8L5.29883 23.5",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8301 16.8L18.7001 23.5",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 20.6299H17.7398",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6496 11.0701H4.34961",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 13.9299H9.12875",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8691 13.9299H16.7791",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRail);
export default __webpack_public_path__ + "static/media/rail.48b89d26.svg";
export { ForwardRef as ReactComponent };